import unauthorizedRedirect from "~/components/utilities/unauthorizedRedirect";

const newForSubmitArticle = async function newForSubmitArticle() {
  try {
    const result = await this.$store.dispatch("newSubmissionVersion", {
      params: {
        id: this.item.id,
      },
    });

    const item = result.itemCreateVersion.newItem;

    this.$root.$emit("change-view", { item, view: "submit-process/step-one" });
  } catch (error) {
    if (
      error.status &&
      error.status.find((err) => err.message === "Access Denied")
    ) {
      unauthorizedRedirect(
        this.$router.replace,
        this.$isServer,
        this.$config,
        undefined
      );
    } else {
      throw error;
    }
  }
};

export default newForSubmitArticle;
